import { ListItem, Typography } from '@mui/material';

import { minorTextGrey } from '@/theme';

export const TransactionQuantityOptionListItem = ({
    label,
    description,
    ...props
}: {
    label: string;
    description?: string | null;
} & React.HTMLAttributes<HTMLLIElement>) => (
    <ListItem
        {...props}
        sx={{
            '&.MuiAutocomplete-option': {
                gap: 0.5,
                justifyContent: 'space-between',
            },
        }}
    >
        {label}
        {description && (
            <Typography variant="caption" sx={{ color: minorTextGrey, textWrap: 'nowrap' }}>
                {description}
            </Typography>
        )}
    </ListItem>
);
